import Topbar from "./TopBar";
import ButtonsBar from "./ButtonsBar";
import BottomBar from "./BottomBar";
import ControlsBar from "./ControlsBar";

const Landscape = {
  Topbar,
  ButtonsBar,
  BottomBar,
  ControlsBar,
};

export default Landscape;
